























































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { SuketBase } from "@/types/suket_sehat_paru";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import SuketSehatParu from "@/services/SuketSehatParu";
import StoreSuketSehatParu from "@/store/modules/SuketSehatParu";
import { storeDokter } from "@/store/modules/dokter";

@Component({
  components: {
    CardModalTtd
  }
})
export default class SuketSehatParuInputCard extends Vue {
  @Prop() readonly register!: string;
  @Prop() dataSuket!: SuketBase;

  register_id = this.dataSuket?.register_id || this.register;
  pasien_rm = this.dataSuket?.pasien_rm || this.pasien.rm;
  unit_id = this.dataSuket?.unit_id || this.user.unit_id;
  nama = this.pasien.nama;
  umur =
    this.dataSuket?.pasien.umur ||
    getAge(formatDMYDate(this.pasien.tgl_lahir))
      .toString()
      .concat(" Th");
  pekerjaan = this.pasien.pekerjaan;
  // alamat = this.dataSuket?.content.alamat || this.pasien.alamat;
  keadaan = this.dataSuket?.content.keadaan || null;
  surat_date = this.dataSuket?.surat_date || new Date();
  signee_user_id = this.dataSuket?.signee_user_id || this.user.id;
  creator_user_id = this.dataSuket?.creator_user_id || this.user.id;
  alamat_type = this.dataSuket?.content.alamat_type;
  kegunaan = this.dataSuket?.content.kegunaan;
  thorax = this.dataSuket?.content.hasil.thorax;
  spirometri = this.dataSuket?.content.hasil.spirometri;
  bta = this.dataSuket?.content.hasil.bta;

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  modalTtdSkJiwa = false;
  saving = false;

  valPemeriksaanNormal = false;
  showInputTujuan = true;
  keadaanOptions = [
    {
      id: 1,
      name: "Tidak Sehat"
    },
    {
      id: 2,
      name: "Sehat Paru"
    },
    {
      id: 3,
      name: "Bebas TB"
    }
  ];

  get pasien() {
    return storePasien.identitasPasien;
  }

  get alamatOptions() {
    const opts = [
      {
        id: "ktp",
        name: this.pasien.alamat,
        category: "Alamat KTP"
      }
    ];

    if (this.pasien.alamat_domisili) {
      opts.push({
        id: "domisili",
        name: this.pasien.alamat_domisili,
        category: "Alamat Domisili"
      });
    }

    return opts;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        alamat_type: this.alamat_type,
        keadaan: this.keadaan,
        hasil: {
          thorax: this.thorax,
          spirometri: this.spirometri,
          bta: this.bta
        },
        kegunaan: this.kegunaan
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? SuketSehatParu.update(this.dataSuket.id, this.input)
        : SuketSehatParu.create(this.input);

      action
        .then(() => {
          if (this.canSign) {
            this.$emit("showSignatureModal");
          }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();
          StoreSuketSehatParu.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");
  }
}
